<template>
  <div>
    <stimulsoft-visualizador ref="visualizador" />
  </div>
</template>
<script>
import { StimulsoftVisualizador } from '@components/misc';
export default {
  components: {
    StimulsoftVisualizador,
  },
  data: function () {
    return {

    };
  },
  methods: {
    inicializarVisualizador: function (resumoOS) {
      this.$refs.visualizador.montarComponente(resumoOS);
    },
  },
};
</script>
